import { Route } from 'react-router-dom';
import FilteredBotels from '../pages/public/FilteredBotels';
import FindABotel from '../pages/public/FindABotel';

export const PublicRoutes = [
  <Route key="home" path="/" element={<FindABotel />} />,
  <Route key="find-botel" path="/botel" element={<FindABotel />} />,
  <Route key="filtered-botels" path="/filtered-botels" element={<FilteredBotels />} />
]; 